import { render } from "./VensysInfoComponent.vue?vue&type=template&id=687e629c&ts=true"
import script from "./VensysInfoComponent.vue?vue&type=script&lang=ts"
export * from "./VensysInfoComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__